import { client } from '@/client';

// 组件详情
export function getComponentBasicInfo(params) {
  return client.post('/api/exec_component_service/cluster/infoFormat', params);
}

// 获取组件列表
export function queryComponentList(params) {
  return client.post('/api/exec_component_service/page-query', params);
}

// 获取主机
export function getComponentHosts(params) {
  return client.post('/api/exec_component_service/hosts/list', params);
}

// 获取K8s主机
export function getComponentK8sHost(params) {
  return client.post('/api/exec_component_service/k8sHosts/list', params);
}

// 获取组件变量
export function getComponentVariables(params) {
  return client.post('/api/exec_component_service/variable/init', params);
}

// 执行
export function runComponent(params) {
  return client.post('/api/exec_component_service/run', params);
}

// 获取K8s主机信息
export function getK8sHosts(params) {
  return client.post('/api/ops_hosts/k8sPageQuery', params);
}

// 物料清单
export function getLibs(params) {
  return client.post('/api/exec_component_service/version/list', params);
}

// 删除物料
export function deleteLib(id) {
  return client.delete(`/api/exec_component_service/version/del/${id}`);
}

// 从版本库获取
export function getLibsFromStore(params) {
  return client.post('/api/exec_component_service/version/pull', params);
}

// 保持无聊
export function saveLib(params) {
  return client.post('/api/exec_component_service/version/save', params);
}
